import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { AppContextProvider } from '../AppLoader';
import { FloatingNotification } from '../Common/FloatingNotification';

export const TwoFAErrorToast: React.FC = observer(() => {
  const {
    rootStore: { notificationStore },
  } = useContext(AppContextProvider);

  return <FloatingNotification store={notificationStore} />;
});
